export const handleOpenPushMenuMobile = (): void => {
    const pushMenu = document.querySelector(".nav_list") as HTMLElement
    if (pushMenu !== null) {
        pushMenu.click()
    }
}
